import {
  LOADER,
  MODAL,
  ACCOUNT,
  SETTING,
  FLOOR,
} from '../../reduxs'
import {
  setLocalStorage,
  setSessionStorage,
  TEXT_ENCRYPT,
  removeLocalStorage,
  removeSessionStorage,
  ROUTE,
  routePath,
  checkPermission,
  PERMISSION_LOGIN,
} from '../../helpers'
import { initServiceWorker, revokeToken } from '../../configs'

import apiService from '../apiService'

export const selectLanguage = (data) => {
  return {
    type: ACCOUNT.actionType.SELECT_LIST_LANGUAGE,
    data
  }
}

export const rememberMe =  (dataUser, history) => {
  return async(dispatch) => {
    dispatch(getProfile())
    dispatch(FLOOR.action.getListFloor({ companyId: dataUser.companyId }))
    dispatch(getListPermission(dataUser, history, () => { }))
  }
}


export const loginUser = (
  params,
  history,
  func = () => { },
) => {
  return async (dispatch) => {
    try {
      dispatch(LOADER.action.displayLoader(true))
      const res = await apiService.post('auth/login', params)

      if (res.status) {
        setLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN, res.data.accessToken)
        setSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN, res.data.accessToken)

        await initServiceWorker()

        setLocalStorage(TEXT_ENCRYPT.IS_LOGIN, 'login')
        setSessionStorage(TEXT_ENCRYPT.IS_LOGIN, 'login')

        dispatch(LOADER.action.displayLoader(false))
        dispatch(FLOOR.action.getListFloor({ companyId: res.data.companyId }))
        dispatch(rememberMe(res.data,history))
      } else {
        removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
        removeSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
        dispatch(MODAL.action.showValidate(res))
        dispatch(LOADER.action.displayLoader(false))
      }
    } catch (error) {
      console.error('ERROR ACTION loginUser :: ', error)
    }
  }
}

export const registerFCMtoken = async (params) => {
  return await apiService.post('rest/v1/create_fcmToken', params)
}

export const resetPasswordSendEmailUser = (param, func = () => { }) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.post('auth/reset_password', param).then(res => {
      if (res.status) {
        dispatch(LOADER.action.displayLoader(false))
        func()
      } else if (!res.status) {
        dispatch(MODAL.action.showValidate(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION resetPasswordSendEmailUser', res)
      }
    })
  }
}

export const verifyEmailUser = (param) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.post('auth/verify_email_token', param).then(res => {
      if (res.status) {
        dispatch(LOADER.action.displayLoader(false))
      } else if (!res.status) {
        dispatch(MODAL.action.showValidate(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION verifyEmailUser', res)
      }
    })
  }
}

export const setPasswordUser = (param, func = () => { }) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.post('auth/set_password', param).then(res => {
      if (res.status) {
        dispatch(LOADER.action.displayLoader(false))
        func()
      } else if (!res.status) {
        removeLocalStorage(TEXT_ENCRYPT.SECTION_ID)
        dispatch(MODAL.action.showValidate(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION setPasswordUser', res)
      }
    })
  }
}

export const createFCMToken = (params) => {
  return dispatch => {
    dispatch(saveFCMRegisterStatus(params))
  }
}

export const saveDataUser = (data) => {
  return {
    type: ACCOUNT.actionType.SAVE_ACCOUNT,
    data
  }
}

export const saveFCMRegisterStatus = (data) => {
  return {
    type: ACCOUNT.actionType.CREATE_FCM,
    data,
  }
}

export const clearAllData = () => {
  removeLocalStorage(TEXT_ENCRYPT.USERNAME)
  removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
  removeSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
  revokeToken()
  return {
    type: ACCOUNT.actionType.CLEAR_ALL_DATA
  }
}

export const getProfile = (param, func = () => { }) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.get('rest/v1/getdetail_profile', param).then(res => {
      if (res.status) {
        dispatch(saveDataProfile(res.data))
        dispatch(LOADER.action.displayLoader(false))
        func()
      } else if (!res.status) {
        dispatch(MODAL.action.showValidate(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION getProfile', res)
      }
    })
  }
}

export const updateProfile = (param, func = () => { }) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    return apiService.postFormData('rest/v1/update_profile', param).then(res => {
      if (res.status) {
        dispatch(MODAL.action.openModalStatus(res))
        dispatch(LOADER.action.displayLoader(false))
        func()
      } else if (!res.status) {
        dispatch(MODAL.action.showValidate(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        console.log('ERROR ACTION updateProfile', res)
      }
    })
  }
}

export const getListPermission = (dataUser, history, func) => {
  return dispatch => {
    dispatch(LOADER.action.displayLoader(true))
    apiService.get('rest/v1/user_permission', {
      userId: dataUser.userId,
      device: 'web',
      accessToken: dataUser.accessToken
    }).then(res => {
      if (res.status) {
        if (res.data.length !== 0) {
          dispatch(SETTING.action.getTheme())
          const permission = res.data.map((e) => {
            return e.permission_key
          })
          const page = routePath().find((data) => {
            return (checkPermission(permission, data.CODE))
          })

          if (page) {
            dispatch(saveDataUser({
              ...dataUser,
              type: '',
              defaultName: '',
              permission,
              isLogin: true,
            }))
            dispatch(MODAL.action.clearValidate())
            dispatch(LOADER.action.displayLoader(false))
            history.push(page.LINK)
          } else {
            removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
            removeSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
            dispatch(MODAL.action.showValidate({
              description: PERMISSION_LOGIN.EN
            }))
            dispatch(LOADER.action.displayLoader(false))
          }
          func()
        } else if (res.data.length === 0) {
          dispatch(MODAL.action.openModalStatus({
            description: PERMISSION_LOGIN.EN
          }))
          dispatch(LOADER.action.displayLoader(false))
        }
      } else if (!res.status) {
        removeLocalStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
        removeSessionStorage(TEXT_ENCRYPT.ACCESS_TOKEN)
        history.push(ROUTE.LOGIN.LINK)
        dispatch(MODAL.action.showValidate(res))
        dispatch(LOADER.action.displayLoader(false))
      } else {
        dispatch(MODAL.action.openModalStatus({
          description: PERMISSION_LOGIN.EN
        }))
        dispatch(LOADER.action.displayLoader(false))
        console.log('ERROR ACTION getListPermission', res)
      }
    })
  }
}

export const saveDataProfile = (data) => {
  return {
    type: ACCOUNT.actionType.SAVE_PROFILE,
    data
  }
}

export const getSessionLogin = (session, history) => {
  return async (dispatch) => {
    try {
      dispatch(LOADER.action.displayLoader(true))
      const res = await apiService.get('auth/getLoginData', {session})

      await initServiceWorker()
      setLocalStorage(TEXT_ENCRYPT.IS_LOGIN, 'login')
      setSessionStorage(TEXT_ENCRYPT.IS_LOGIN, 'login')
      dispatch(rememberMe(res.data, history))
    } catch (error) {
      console.error('ERROR ACTION getSessionLogin:', error)
    }
    dispatch(LOADER.action.displayLoader(false))
  }
}
